import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-questiontype",
  templateUrl: "./field-set-questiontype.component.html",
})
export class FieldSetQuestiontypeComponent {
  @Input() public fieldOptions: any;
  @Input() public relatedDeterminants: any[] = [];
  @Input() public jsonDeterminants: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

  public isDisabled() {
    const hasRelatedDeterminants = (this.relatedDeterminants && this.relatedDeterminants.length > 0);
    const hasJsonDeterminants = this.jsonDeterminants !== "" && this.jsonDeterminants !== '[{"type":"OR","items":[]}]';
    return hasRelatedDeterminants || hasJsonDeterminants;
  }
}
